import React from 'react';
import {
  TrendingUp,
  TrendingDown,
  Users,
  Activity,
  DollarSign,
  BarChart3,
  Brain,
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './Analytics.css';

const Analytics = () => {
  const navigate = useNavigate();

  const metrics = [
    {
      title: 'Total Revenue',
      value: '$45,231',
      change: '+20.1%',
      changeType: 'positive',
      icon: DollarSign,
      color: '#10b981',
    },
    {
      title: 'Active Users',
      value: '2,350',
      change: '+180.1%',
      changeType: 'positive',
      icon: Users,
      color: '#3b82f6',
    },
    {
      title: 'Sales',
      value: '12,234',
      change: '+19%',
      changeType: 'positive',
      icon: TrendingUp,
      color: '#f59e0b',
    },
    {
      title: 'Active Sessions',
      value: '573',
      change: '-12%',
      changeType: 'negative',
      icon: Activity,
      color: '#ef4444',
    },
  ];

  const chartData = [
    { month: 'Jan', users: 400, revenue: 2400 },
    { month: 'Feb', users: 300, revenue: 1398 },
    { month: 'Mar', users: 200, revenue: 9800 },
    { month: 'Apr', users: 278, revenue: 3908 },
    { month: 'May', users: 189, revenue: 4800 },
    { month: 'Jun', users: 239, revenue: 3800 },
    { month: 'Jul', users: 349, revenue: 4300 },
  ];

  const handleBeliefAnalyticsClick = () => {
    navigate('/beliefanalytics');
  };

  return (
    <div className="analytics-page">
      <div className="analytics-header">
        <h2>Analytics Dashboard</h2>
        <p>Track your system performance and user engagement</p>
        <div className="analytics-actions">
          <button className="belief-analytics-btn" onClick={handleBeliefAnalyticsClick}>
            <Brain size={20} />
            Belief Analytics
          </button>
        </div>
      </div>

      <div className="metrics-grid">
        {metrics.map((metric, index) => {
          const Icon = metric.icon;
          return (
            <div key={index} className="metric-card">
              <div className="metric-icon" style={{ backgroundColor: metric.color }}>
                <Icon size={24} color="white" />
              </div>
              <div className="metric-content">
                <h3 className="metric-title">{metric.title}</h3>
                <p className="metric-value">{metric.value}</p>
                <span className={`metric-change metric-change-${metric.changeType}`}>
                  {metric.change}
                </span>
              </div>
            </div>
          );
        })}
      </div>

      <div className="charts-section">
        <div className="chart-grid">
          <div className="chart-card">
            <div className="chart-header">
              <h3>User Growth</h3>
              <div className="chart-legend">
                <span className="legend-item">
                  <span className="legend-color" style={{ backgroundColor: '#3b82f6' }}></span>
                  Users
                </span>
              </div>
            </div>
            <div className="chart-placeholder">
              <BarChart3 size={48} color="#94a3b8" />
              <p>Chart visualization would go here</p>
              <div className="chart-data">
                {chartData.map((data, index) => (
                  <div key={index} className="data-point">
                    <span className="data-label">{data.month}</span>
                    <span className="data-value">{data.users}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="chart-card">
            <div className="chart-header">
              <h3>Revenue Trends</h3>
              <div className="chart-legend">
                <span className="legend-item">
                  <span className="legend-color" style={{ backgroundColor: '#10b981' }}></span>
                  Revenue
                </span>
              </div>
            </div>
            <div className="chart-placeholder">
              <TrendingUp size={48} color="#94a3b8" />
              <p>Chart visualization would go here</p>
              <div className="chart-data">
                {chartData.map((data, index) => (
                  <div key={index} className="data-point">
                    <span className="data-label">{data.month}</span>
                    <span className="data-value">${data.revenue}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="insights-section">
        <div className="insights-grid">
          <div className="insight-card">
            <h3>Top Performing Features</h3>
            <div className="insight-list">
              <div className="insight-item">
                <span className="insight-rank">1</span>
                <span className="insight-text">User Authentication</span>
                <span className="insight-value">98%</span>
              </div>
              <div className="insight-item">
                <span className="insight-rank">2</span>
                <span className="insight-text">Data Processing</span>
                <span className="insight-value">95%</span>
              </div>
              <div className="insight-item">
                <span className="insight-rank">3</span>
                <span className="insight-text">API Response</span>
                <span className="insight-value">92%</span>
              </div>
            </div>
          </div>

          <div className="insight-card">
            <h3>Recent Activity</h3>
            <div className="activity-timeline">
              <div className="timeline-item">
                <div className="timeline-dot"></div>
                <div className="timeline-content">
                  <p>System backup completed successfully</p>
                  <span className="timeline-time">2 hours ago</span>
                </div>
              </div>
              <div className="timeline-item">
                <div className="timeline-dot"></div>
                <div className="timeline-content">
                  <p>New user registration spike detected</p>
                  <span className="timeline-time">4 hours ago</span>
                </div>
              </div>
              <div className="timeline-item">
                <div className="timeline-dot"></div>
                <div className="timeline-content">
                  <p>Database optimization completed</p>
                  <span className="timeline-time">6 hours ago</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Analytics;
